import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import { armCurrency } from "./currency.js"
// Arms itself on DOMContentLoaded, and does nothing at all on a build with
// `sales.enabled` unset: without the panel in the page there is nothing to ask.
import "./sales-tracking.js"
// Adds an ad's click identifier and campaign to download links on DOMContentLoaded.
import "./download-tracking.js"

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)")

// Looping demos autoplay, unless the reader asked for less motion, in which
// case the poster still stands in for the loop.
const holdLoops = () => {
  document.querySelectorAll("video.loop").forEach((video) => {
    if (reduceMotion.matches) {
      video.autoplay = false
      video.pause()
      video.load()
    } else if (video.paused) {
      video.play().catch(() => {})
    }
  })
}

// A recording with a walkthrough in it waits to be asked.
const armPlayers = () => {
  document.querySelectorAll("[data-player]").forEach((player) => {
    const video = player.querySelector("video")
    const button = player.querySelector("[data-play]")
    if (!video || !button) return

    const start = () => {
      button.hidden = true
      video.play().catch(() => {})
    }

    button.addEventListener("click", start)
    video.addEventListener("play", () => {
      button.hidden = true
    })
  })
}

// The overview is on YouTube. Its still and its button stand in for the
// player until the reader asks for it, so nothing is requested from Google
// on load.
const armEmbeds = () => {
  document.querySelectorAll("[data-embed]").forEach((player) => {
    const button = player.querySelector("[data-play]")
    if (!button) return

    button.addEventListener("click", () => {
      const frame = document.createElement("iframe")
      frame.src = `https://www.youtube-nocookie.com/embed/${player.dataset.embed}?autoplay=1&rel=0`
      frame.title = player.dataset.embedTitle || "Recording"
      frame.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen"
      frame.allowFullscreen = true
      frame.referrerPolicy = "strict-origin-when-cross-origin"
      player.replaceChildren(frame)
    })
  })
}

// The before and after stills are laid out two to a row, which is small
// enough that the point of them, the text in the message list, cannot be
// read. Pressing one opens it over the page at the size the file holds.
// One dialog serves every still; it is built on the first press.
const armZoom = () => {
  const triggers = document.querySelectorAll("[data-zoom]")
  if (!triggers.length) return

  let dialog = null
  let picture = null
  let label = null

  const build = () => {
    dialog = document.createElement("dialog")
    dialog.className = "lightbox"

    picture = document.createElement("img")
    label = document.createElement("p")
    label.className = "lightbox-caption"

    const close = document.createElement("button")
    close.type = "button"
    close.className = "lightbox-close"
    close.setAttribute("aria-label", "Close")
    close.textContent = "×"
    close.addEventListener("click", () => dialog.close())

    dialog.append(close, picture, label)
    // The backdrop is part of the dialog, so a press outside the picture
    // lands here rather than on a child of it.
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close()
    })
    document.body.append(dialog)
  }

  triggers.forEach((trigger) => {
    const source = trigger.querySelector("img")
    if (!source) return

    trigger.addEventListener("click", () => {
      if (!dialog) build()
      picture.src = source.currentSrc || source.src
      picture.alt = source.alt
      const caption = trigger.closest("figure")?.querySelector("figcaption")
      label.textContent = caption ? caption.textContent.trim() : ""
      label.hidden = !label.textContent
      dialog.showModal()
    })
  })
}

const init = () => {
  holdLoops()
  armPlayers()
  armEmbeds()
  armZoom()
  armCurrency()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}

reduceMotion.addEventListener("change", holdLoops)
